var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyzeTypeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 450,
    viewBox: "0 0 510 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8643
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2983 20.9996C77.2983 19.4816 78.5289 18.251 80.047 18.251C81.565 18.251 82.7956 19.4816 82.7956 20.9996C82.7956 22.5176 81.565 23.7482 80.047 23.7482C78.5289 23.7482 77.2983 22.5176 77.2983 20.9996Z",
    fill: "#C27AFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.210638
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.994 192.375C298.994 191.259 299.899 190.354 301.016 190.354C302.132 190.354 303.038 191.259 303.038 192.375C303.038 193.492 302.132 194.397 301.016 194.397C299.899 194.397 298.994 193.492 298.994 192.375Z",
    fill: "#C27AFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.775528
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.137 87.0157C288.137 85.5422 289.331 84.3477 290.805 84.3477C292.278 84.3477 293.473 85.5422 293.473 87.0157C293.473 88.4892 292.278 89.6838 290.805 89.6838C289.331 89.6838 288.137 88.4892 288.137 87.0157Z",
    fill: "#C27AFF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.243412
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.901 346.195C474.901 345.04 475.837 344.104 476.992 344.104C478.147 344.104 479.084 345.04 479.084 346.195C479.084 347.35 478.147 348.287 476.992 348.287C475.837 348.287 474.901 347.35 474.901 346.195Z",
    fill: "#C27AFF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.263508
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.812 85.031C366.812 83.8532 367.767 82.8984 368.945 82.8984C370.123 82.8984 371.078 83.8532 371.078 85.031C371.078 86.2087 370.123 87.1635 368.945 87.1635C367.767 87.1635 366.812 86.2087 366.812 85.031Z",
    fill: "#C27AFF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.308516
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.298 203.719C375.298 202.489 376.294 201.493 377.523 201.493C378.752 201.493 379.749 202.489 379.749 203.719C379.749 204.948 378.752 205.944 377.523 205.944C376.294 205.944 375.298 204.948 375.298 203.719Z",
    fill: "#C27AFF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.417126
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.153 308.921C224.153 307.578 225.242 306.488 226.586 306.488C227.93 306.488 229.019 307.578 229.019 308.921C229.019 310.265 227.93 311.355 226.586 311.355C225.242 311.355 224.153 310.265 224.153 308.921Z",
    fill: "#C27AFF"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.801784
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.743 64.9375C456.743 63.2898 458.079 61.9541 459.727 61.9541C461.374 61.9541 462.71 63.2898 462.71 64.9375C462.71 66.5851 461.374 67.9208 459.727 67.9208C458.079 67.9208 456.743 66.5851 456.743 64.9375Z",
    fill: "#C27AFF"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.694266
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.682 204.835C109.682 203.409 110.839 202.252 112.266 202.252C113.692 202.252 114.849 203.409 114.849 204.835C114.849 206.262 113.692 207.419 112.266 207.419C110.839 207.419 109.682 206.262 109.682 204.835Z",
    fill: "#C27AFF"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.200966
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.733 350.531C489.733 349.426 490.629 348.53 491.734 348.53C492.839 348.53 493.735 349.426 493.735 350.531C493.735 351.636 492.839 352.532 491.734 352.532C490.629 352.532 489.733 351.636 489.733 350.531Z",
    fill: "#C27AFF"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48595
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.953 85.4296C283.953 84.1266 285.01 83.0703 286.312 83.0703C287.615 83.0703 288.672 84.1266 288.672 85.4296C288.672 86.7325 287.615 87.7888 286.312 87.7888C285.01 87.7888 283.953 86.7325 283.953 85.4296Z",
    fill: "#C27AFF"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.379888
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.248 359.219C147.248 357.915 148.305 356.857 149.609 356.857C150.914 356.857 151.971 357.915 151.971 359.219C151.971 360.523 150.914 361.58 149.609 361.58C148.305 361.58 147.248 360.523 147.248 359.219Z",
    fill: "#C27AFF"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.500215
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.531 69.8905C319.531 68.4581 320.693 67.2969 322.125 67.2969C323.557 67.2969 324.719 68.4581 324.719 69.8905C324.719 71.3229 323.557 72.4841 322.125 72.4841C320.693 72.4841 319.531 71.3229 319.531 69.8905Z",
    fill: "#C27AFF"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.517165
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.669 48.9144C415.669 47.4634 416.846 46.2871 418.297 46.2871C419.748 46.2871 420.924 47.4634 420.924 48.9144C420.924 50.3654 419.748 51.5417 418.297 51.5417C416.846 51.5417 415.669 50.3654 415.669 48.9144Z",
    fill: "#C27AFF"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.944851
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.53 165.289C151.53 163.731 152.793 162.468 154.352 162.468C155.91 162.468 157.173 163.731 157.173 165.289C157.173 166.848 155.91 168.111 154.352 168.111C152.793 168.111 151.53 166.848 151.53 165.289Z",
    fill: "#C27AFF"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.232264
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.205 372.664C489.205 371.522 490.131 370.596 491.273 370.596C492.416 370.596 493.342 371.522 493.342 372.664C493.342 373.807 492.416 374.733 491.273 374.733C490.131 374.733 489.205 373.807 489.205 372.664Z",
    fill: "#C27AFF"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.509402
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.494 447.312C463.494 445.867 464.665 444.696 466.109 444.696C467.554 444.696 468.725 445.867 468.725 447.312C468.725 448.757 467.554 449.928 466.109 449.928C464.665 449.928 463.494 448.757 463.494 447.312Z",
    fill: "#C27AFF"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.257625
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.454 325.93C276.454 324.778 277.387 323.845 278.539 323.845C279.691 323.845 280.624 324.778 280.624 325.93C280.624 327.081 279.691 328.015 278.539 328.015C277.387 328.015 276.454 327.081 276.454 325.93Z",
    fill: "#C27AFF"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.276177
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.882 206.133C262.882 204.941 263.848 203.976 265.039 203.976C266.23 203.976 267.196 204.941 267.196 206.133C267.196 207.324 266.23 208.29 265.039 208.29C263.848 208.29 262.882 207.324 262.882 206.133Z",
    fill: "#C27AFF"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.703892
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.191 109.867C293.191 108.433 294.355 107.27 295.789 107.27C297.224 107.27 298.387 108.433 298.387 109.867C298.387 111.302 297.224 112.465 295.789 112.465C294.355 112.465 293.191 111.302 293.191 109.867Z",
    fill: "#C27AFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzeTypeBg);
export default __webpack_public_path__ + "static/media/analyze-type-bg.0f89d37bca58132695cf710af04d825b.svg";
export { ForwardRef as ReactComponent };